<template>
  <div @contextmenu="clickDestro($event)" @click="menu_contestuale_visible = false"
    style="display: flex; justify-content: center; align-items: center">
    <!-- <v-card
      id="menu_contestuale"
      style="position: absolute; z-index: 99"
      v-show="menu_contestuale_visible"
      class="mx-auto"
    >
      <v-toolbar color="light-blue" dense dark>
        <v-toolbar-title>Settings</v-toolbar-title>
      </v-toolbar>

      <v-list>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-content @click="dialog_img = true">
              <v-list-item-title>Sfondo</v-list-item-title>
              <v-list-item-subtitle
                >Carica un immagine dal computer locale</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card> -->
    <video id="background-video" muted>
      <source src="../assets/Depositphotos_151324262_1080p.mp4" type="video/mp4" />
    </video>
    <!-- <img id="background-img" src="../assets/Ind.jpg" alt=""> -->
    <div class="fixed">
      <v-spacer></v-spacer>
      <img class="tokenImageProfile" :src="img_azienda" />
      <h2 v-if="img_azienda == null" style="color: #212427">
        {{ testo_azienda }}
      </h2>
      <v-spacer></v-spacer>

      <!--<v-row >
        <v-col><v-autocomplete v-if="moduli_sx.length >= 10" dense rounded :items="moduli_sx" item-text="des_modulo" solo label="Ricerca modulo"
        v-model="search_modulo" prepend-inner-icon="mdi-magnify" theme="light" @change="filterModules"></v-autocomplete></v-col>
        <v-col v-if="search_modulo != ''" cols="1">
          <v-btn small rounded class="mt-1" @click="removeFilter">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
          
        </v-col>
      </v-row>-->
    </div>
    <div class="card-container">
      <div v-for="item in moduli_vis" :key="item.id_modulo">
        <div class="card" @click="apriModulo(item)">
          <Tilt class="card-tilt" :parallax="true" :options="{ glare: true, 'max-glare': 0.1, speed: 50, max: 2 }">
            <div class="nft">
              <div class="main">
                <div>
                  <img class="tokenImage" v-if="item.img_modulo"
                    :src="item.img_modulo == null ? '' : item.img_modulo" />
                  <h3 v-else class="title-module container-image" style="color: #212427">
                    {{ item.des_modulo }}
                  </h3>
                </div>
                <!-- <p v-if="item.img_modulo" class="tokenImageTitle" style="font-size: 14px; margin-top: 1px; font-weight: 500;">
                  {{ item.des_modulo }}
                </p> -->
              </div>
            </div>
          </Tilt>
        </div>
      </div>
      <!-- <div class="card" @click="apriAllegati">
        <Tilt class="card-tilt" :parallax="true" :options="{ glare: true, 'max-glare': 0.2, speed: 100, max: 8 }">
          <div class="nft">
            <div class="main">
              <div class="container-image">
                  <img class="tokenImage"
                    src="../assets/piu-sviluppo_logo-bianco.png" />
                </div>
                <p style="color: #555; font-size: 15px; margin-top: 1px;">
                  Allegati New
                </p>
            </div>
          </div>
        </Tilt>
      </div> -->

      <!-- Card che da accesso al preventivatore -->
       <!-- <div class="card" @click="apriCad">
        <Tilt class="card-tilt" :parallax="true" :options="{ glare: true, 'max-glare': 0.2, speed: 100, max: 8 }">
          <div class="nft2">
            <div class="main">
              <div class="container-image">
                  <img class="tokenImage"
                    src="../assets/piu-sviluppo_logo-bianco.png" />
                </div>
            </div>
          </div>
        </Tilt>
      </div>  -->
      <!-- Card che da accesso MAP -->
      <!-- <div class="card" @click="apriGeo">
        <Tilt class="card-tilt" :parallax="true" :options="{ glare: true, 'max-glare': 0.2, speed: 100, max: 8 }">
          <div class="nft2">
            <div class="main">
              <div class="container-image">
                  <img class="tokenImage"
                    src="../assets/piu-sviluppo_logo-bianco.png" />
                </div>
            </div>
          </div>
        </Tilt>
      </div> -->
    </div>

    <v-dialog v-model="dialog_iframe" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-btn icon dark @click="dialog_iframe = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe :src="link" style="display: block; height: 100vh" width="100%"></iframe>
      </v-card>
    </v-dialog>

    <!-- DIALOG COMPONENTE ESTERNO allegati -->
    <v-dialog v-model="dialog_allegati" width="80%">
      <v-card style="overflow: hidden" height="calc(100vh - 100px)">
        <div style="position: relative; height: 100%">
          <WindowFrame ref="windowframe_allegati" :component="'newallegati'" :input_args="{
            id_riferimento: 4,
            cod_riferimento: 'anagrafica',
            pk_riferimento: 'id_anagrafica',
          }" @click_chiudi="dialog_allegati = false" />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_cad" width="90%">
      <v-card style="overflow: hidden" height="calc(100vh - 100px)">
        <div style="overflow: hidden; position: relative; height: 100%">
          <WindowFrame style="overflow: hidden" ref="windowframe_cad" :component="'cadwindow'"
            @click_chiudi="dialog_cad = false" />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_geo" width="90%">
      <v-card style="overflow: hidden" height="calc(100vh - 100px)">
        <div style="overflow: hidden; position: relative; height: 100%">
          <WindowFrame style="overflow: hidden" ref="windowframe_geo" :component="'geolocation'"
            @click_chiudi="dialog_geo = false" @chiudi_maps="dialog_geo = false" />
        </div>
      </v-card>
    </v-dialog>

    <!-- DIALOG INIZIO SESSIONE LAVORATIVA -->
    <!-- <v-dialog
      persistent
      v-model="dialog_registrazione"
      hide-overlay
      transition="dialog-bottom-transition"
      width="500"
    >
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-toolbar-title> Registrazione lavorativa </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn light small v-bind="attrs" v-on="on" @click="apriPresenze">
                <v-icon color="primary">mdi-table</v-icon>
              </v-btn>
            </template>
<span>Visualizza presenze</span>
</v-tooltip>
<v-spacer></v-spacer>
</v-toolbar>
<v-card-text>
  <v-row class="mt-3">
    <v-col>
      <span style="color: black; font-size: 20px">Confermi di iniziare l'orario lavorativo alle
        {{ now.getHours() + ":" + now.getMinutes() }}?</span>
    </v-col>
  </v-row>
  <v-row justify="center" align="center">
    <v-col>
      <span style="color: red; font-size: 18px; cursor: pointer" @click="clickAnnullaRegistrazione">Annulla</span>
    </v-col>
    <v-col>
      <v-btn @click="clickConfermaInizio" color="success">CONFERMA</v-btn>
    </v-col>
  </v-row>
</v-card-text>
</v-card>
</v-dialog> -->

    <!-- DIALOG PRESENZE -->
    <!-- <v-dialog
      persistent
      v-model="dialog_presenze"
      transition="dialog-bottom-transition"
      width="600px"
    >
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-toolbar-title>
            Elenco Presenze - {{ nome_utente }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                light
                small
                v-bind="attrs"
                v-on="on"
                @click="dialog_presenze = false"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table :headers="headers_presenze" :items="lista_presenze">
          <template v-slot:[`item.data`]="{ item }">
            {{ formatData(item.data) }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog> -->

    <!-- <v-dialog
      :scrollable="false"
      hide-overlay
      persistent
      v-model="dialog_img"
      width="600"
    >
      <v-card>
        <v-toolbar color="primary" dense>
          <v-toolbar-title class="white--text">Carica Immagine</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiUploadFile" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="text-align: center" class="mt-5">
          <v-file-input
            accept="image/*"
            @change="
              uploadImage(img_upload_editor);
              chiudiUploadFile();
            "
            style="display: inline-block; width: 400px"
            type="file"
            v-model="img_upload_editor"
          />
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import { encrypt } from "@/components/TOOLS/FormComponentPermissions/PermissionCrypto.js";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import Tilt from "vanilla-tilt-vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  props: {
    source: String,
  },
  components: {
    SnackbarQV,
    Tilt,
    WindowFrame,
  },
  computed: {},
  data: () => ({
    // da eliminare dopo allegati
    dialog_allegati: false,
    prefisso_utente: null,
    // da eliminare dopo cad
    dialog_cad: false,
    dialog_geo: false,
    key_allegati: 0,
    key_windowframe: 0,
    dialog_iframe: false,
    dialog_presenze: false,
    dialog_registrazione: false,
    headers_presenze: [
      { text: "Data", value: "data" },
      { text: "Ora inizio", value: "ora_inizio" },
      { text: "Ora fine", value: "ora_fine" },
    ],
    search_modulo: "",
    id_azienda: localStorage.id_azienda,
    link: "",
    moduli_dx: [],
    moduli_sx: [],
    nome_utente: localStorage.nominativo,
    orari_attivi: localStorage.orari_attivi,
    utente_registered: localStorage.registered,
    now: new Date(),
    lista_presenze: [],
    menu_contestuale_visible: false,
    work_time_registered: false,
    testo_azienda: "",
    img_azienda: "",
    dialog_img: false,
    img_upload_editor: null,
    background_page: null,
    dialog_modulo_prova: false,
    dialog_modulo_prova2: false,
    moduli_vis: [],
    // DA ELIMINARE
    dialog_corsi_formazione: false,
  }),
  created() {
    if (localStorage.moduli_dx !== "undefined") {
      this.moduli_dx = JSON.parse(localStorage.moduli_dx);
    }
    if (localStorage.moduli_sx !== "undefined")
      this.moduli_sx = JSON.parse(localStorage.moduli_sx);
    this.moduli_vis = JSON.parse(localStorage.moduli_sx);
  },
  async mounted() {
    // L'elemento qui sotto è il video di sfondo.
    // let vid = document.getElementById("background-video");
    // console.log(vid);

    // await this.getPresenze();
    this.testo_azienda = this.$store.state.testo_azienda;
    this.prefisso_utente = this.$store.state.prefisso_utente;
    this.img_azienda = localStorage.img_azienda;

    const timer = 3000;
    let counter = 0;
    const counter_step = 100;

    const that = this;
    let chk_img = setInterval(function () {
      counter += counter_step;
      let stop_chk = false;
      if (
        (localStorage.img_azienda !== null &&
          localStorage.img_azienda !== undefined &&
          localStorage.img_azienda !== "") ||
        counter > timer
      ) {
        stop_chk = true;
        that.img_azienda = localStorage.img_azienda;
      }

      if (stop_chk) {
        clearInterval(chk_img);
      }
    }, counter_step);

    this.getFormAutorizzazioni();
    //if (this.nome_utente == "Marco Minnella" && this.work_time_registered == false ) {
    if (this.orari_attivi == "true" && this.work_time_registered == false) {
      if (this.utente_registered == "true") {
        return;
      } else {
        this.dialog_registrazione = true;
      }
    }
  },
  watch: {
    // "$store.state.testo_azienda": function () {
    //   console.log("local img change", this.$store.state.img_azienda);
    //   this.img_azienda = this.$store.state.img_azienda;
    //   this.testo_azienda = this.$store.state.testo_azienda;
    // },
    // "$store.state.img_azienda": function () {
    //   console.log("local img change", this.$store.state.img_azienda);
    //   this.img_azienda = this.$store.state.img_azienda;
    // },
  },
  methods: {
    apriAllegati() {
      this.dialog_allegati = true;
    },
    apriCad() {
      this.dialog_cad = true;
    },
    apriGeo() {
      this.dialog_geo = true;
    },
    apriIframe(link) {
      this.link = link;
    },
    apriModulo(item) {
      if (item.link != null) {
        // this.dialog_iframe = true;
        this.link = item.link;
        window.open(this.link, "_blank");
      } else {
        localStorage.id_modulo_selezionato = item.id_modulo;
        var request = {
          controller: "User",
          method: "POST",
          richiesta: {
            action: "getmenu",
            token: localStorage.user_token,
            id_utente: localStorage.id,
            db_name: "medical",
            id_modulo: item.id_modulo,
            id_profilo_utente: localStorage.id_profilo,
            id_azienda: localStorage.id_azienda,
          },
        };
        this.$store.dispatch("api", request).then((res) => {
          if (Number(item.dinamico) == 1) {
            res.data.forEach((modulo_menu) => {
              const new_path =
                "/home/module/" +
                item.cod_modulo.toLowerCase() +
                modulo_menu.path;
              modulo_menu.path = new_path;
            });
          }
          localStorage.setItem("menu", JSON.stringify(res.data));
          if (item.json_parametri != null) {
            let params = item.json_parametri.split(",");
            let parametroChiamate = params[0] == undefined ? null : params[0];
            let parametroComponente = params[1] == undefined ? null : params[1];
            localStorage.setItem("parametro_chiamata", parametroChiamate);
            localStorage.setItem("parametro_componente", parametroComponente);
          }
          this.$store.state.menu_sx = res.data;
        });
      }
    },
    // apriPresenze() {
    //   this.getPresenze();
    //   this.dialog_presenze = true;
    // },
    clickAnnullaRegistrazione() {
      localStorage.setItem("registered", "true");
      this.dialog_registrazione = false;
    },
    clickConfermaInizio() {
      var request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setpresenze",
          token: localStorage.user_token,
          data: [
            {
              id_presenze: -1,
              id_utente: localStorage.id,
              ora_inizio: this.now.getHours() + ":" + this.now.getMinutes(),
              data: this.now,
              ora_fine: null,
            },
          ],
        },
      };
      this.$store.dispatch("api", request).then(async (res) => {
        console.log(res);
        if (res.status == 200) {
          this.dialog_registrazione = false;
          this.$refs.SnackbarQV.print("success", "Orario registrato.");
        } else {
          this.dialog_registrazione = false;
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        }
      });
    },
    clickDestro(e) {
      e.preventDefault();
      console.log("click des", e);

      // Rendo visibile il menu contestuale e lo posiziono.
      // this.menu_contestuale_visible = true;
      // document.getElementById("menu_contestuale").style.position = "absolute";
      // document.getElementById("menu_contestuale").style.left = e.clientX + "px";
      // document.getElementById("menu_contestuale").style.top =
      //   e.clientY - 40 + "px";
    },
    filterModules() {
      console.log("entra");
      if (this.search_modulo != "") {
        this.moduli_vis = this.moduli_sx.filter((e) =>
          e.des_modulo.includes(this.search_modulo)
        );
      } else {
        this.moduli_vis = this.moduli_sx;
      }
    },
    formatData(data) {
      if (data != null) {
        data = data.split("T");
        return data == null || data[0] == ""
          ? "N/D"
          : moment(data[0]).format("DD/MM/YYYY");
      }
    },
    chiudiUploadFile() {
      this.dialog_img = false;
    },
    getFormAutorizzazioni() {
      var request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getformautorizzazioni",
          token: localStorage.user_token,
        },
      };
      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200 && res.data.length > 0) {
          await encrypt(JSON.stringify(res.data));
        } else {
          await encrypt(JSON.stringify([]));
        }
      });
    },
    // async getPresenze() {
    //   await new Promise((resolve) => {
    //     var request = {
    //       controller: "Manutenzione",
    //       method: "POST",
    //       richiesta: {
    //         action: "getpresenze",
    //         token: localStorage.user_token,
    //         id_utente: localStorage.id,
    //       },
    //     };
    //     this.$store.dispatch("api", request).then(async (res) => {
    //       this.lista_presenze = res.data.presenze.t_presenze;

    //       var data = moment(this.now).format("YYYY-MM-DD");

    //       this.lista_presenze.forEach((e) => {
    //         if (e.data.split("T")[0] == data) {
    //           this.work_time_registered = true;
    //         }
    //       });
    //       resolve();
    //     });
    //   });
    // },
    goToManutenzione() {
      this.$router.push("/home/manutenzione/main");
    },
    removeFilter() {
      this.moduli_vis = this.moduli_sx;
      this.search_modulo = "";
    },
    uploadImage(val) {
      let that = this;

      let reader = new FileReader();

      reader.onload = function () {
        // Registro l'immagine come Base64.

        let img = new Image();

        img.onload = function () {
          /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
           * e dimensiono il div in maniera da accoglierla senza stretcharla.
           * Voglio che le dimensioni dell'immagine non siano mai
           * superiori a 100 px; se lo sono scalo le dimesioni.*/
          that.background_page = img.src;
        };
        img.src = reader.result;
      };

      reader.onerror = function (error) {
        console.log("Error: ", error);
      };

      reader.readAsDataURL(val);
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #161418;
  color: #eee;
  user-select: none;
}

#background-video {
  width: 100vw;
  /* height: 110vh; */
  position: fixed;
  left: -30px;
  top: 0;
  filter: opacity(0.98) blur(10px) brightness(1.2);
  transform: scale(1.1);
}

#background-img {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0px;
  top: 0;
}

.fixed {
  position: fixed;
  max-width: 300px;
  min-width: 300px;
  top: 100px;
  margin-left: 50px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 250px;
  margin-left: 50px;
  width: 80%;
}

.card-tilt {
  border-radius: 12px;
}

.card {
  margin: 10px;
  border-radius: 1.2rem;
}

.nft {
  user-select: none;
  max-width: 145px;
  min-width: 145px;
  min-height: 170px;
  max-height: 170px;
  /* border: 1px solid rgb(255, 255, 255); */
  /* background: rgba(255, 255, 255, 0.732); */
  background: #ffffff;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.981) 0%, rgba(255, 255, 255, 0.936) 50%, rgb(255, 255, 255) 100%);
  box-shadow: rgba(22, 22, 22, 0.711) 0px 6px 22px -2px,
    rgba(48, 48, 48, 0.605) 0px 3px 7px -3px;
  border-radius: 12px;
  backdrop-filter: blur(90px);
  -webkit-backdrop-filter: blur(90px);
  filter: brightness(0.95);
  overflow: hidden;
  transition: 0.2s all;
}

.nft .main .container-image {
  padding: 4px;
  display: flex;
  max-width: 144px;
  min-width: 144px;
  min-height: 144px;
  max-height: 144px;
}

.nft .main .tokenImage {
  /* max-width: 120px;
  min-width: 120px; */
  min-height: 144px;
  max-height: 144px;
  transition: all 0.4s linear;
  object-fit: contain;
  /* filter: brightness(1.1); */
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* z-index: 999; */
}

/* .nft .main .tokenImageTitle {
  color: rgba(47, 47, 47, 0.858);
  display: block;
  position: absolute;
  top: 85%;
  left: 5%;
} */

.tokenImageProfile {
  /* margin-top: -10px; */
  border-radius: 0.5rem;
  height: 100px;
}

.nft .main .tokenInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-module {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px auto;
}

.nft:hover {
  /* border: 0.1px solid rgba(57, 57, 57, 0.574); */
  box-shadow: 1px 8px 22px 1px rgba(30, 30, 30, 0.7);
  backdrop-filter: blur(90px);
  -webkit-backdrop-filter: blur(90px);
   filter: brightness(1.1);
}

/* .nft:hover ::before {
  background: #ffffff;
  filter: brightness(0.8);
  top: -100%;
  left: 200%;
} */
.nft2 {
  user-select: none;
  max-width: 144px;
  min-width: 144px;
  min-height: 170px;
  max-height: 170px;
  border: 0.5px solid rgba(174, 174, 174, 0.462);
  background: rgba(46, 46, 46, 0.9);
  box-shadow: rgba(50, 50, 93, 0.404) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.582) 0px 3px 7px -3px;
  border-radius: 12px;
  backdrop-filter: blur(80px);
  -webkit-backdrop-filter: blur(80px);
  filter: brightness(0.92);
  overflow: hidden;
  transition: 0.2s all;
}

.nft2 .main .container-image {
  display: flex;
  max-width: 144px;
  min-width: 144px;
  min-height: 144px;
  max-height: 144px;
}

.nft2 .main .tokenImage {
  transition: all 0.4s linear;
  transform: scale(0.9);
  border-radius: 10px;
  max-width: 100%;
  min-width: 100%;
  max-height: 144px;
  object-fit: scale-down;
  filter: brightness(1.1);
  z-index: 999;
}
</style>
